module.exports = __webpack_public_path__ + "static/img/53-1.d0bfdb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/53-1.jpg
// module id = zkbo
// module chunks = 0